import React, { useContext } from 'react';
import { BsSunFill, BsGithub } from "react-icons/bs"
import { RiMoonFill } from "react-icons/ri"
import { GrLinkedinOption } from "react-icons/gr"
// import icons
import { social } from '../data';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { ThemeContext } from '../context/ThemeContext';
import { Link } from 'react-scroll';

const Socials = () => {
  const { Theme, changeTheme } = useContext(ThemeContext)
  return (
    <ul className='flex space-x-6 '>
      <li>
        <Flex alignItems={"center"} h="43px" px="3" onClick={changeTheme} borderRadius={"5px"} background={Theme === 'dark' ? '#F2AA4CFF' : "red.400"} >
          <Icon fontSize={"20px"} color={Theme === 'dark' ? 'blackAlpha.800' : "#fff"} as={Theme === "dark" ? BsSunFill : RiMoonFill} />
        </Flex >
      </li>

      <li>
        <Flex alignItems={"center"} h="43px" px="3" borderRadius={"5px"} background={Theme === 'dark' ? '#F2AA4CFF' : "red.400"} >
          <a className={` ${Theme === "dark" ? "text-black.400" : "text-white"}`} href="https://drive.google.com/file/d/19uosWZY4Z7TO0kD4c0Ia9kSKqPQUewRA/view" target='blank'>
            <Text fontWeight={"500"} color={Theme === 'dark' ? 'blackAlpha.800' : "#fff"}   >

              Resume
            </Text>
          </a>
        </Flex >
      </li>
      {social.map((item, index) => {
        return (
          <li
            className={`flex justify-center items-center ${Theme === "dark" ? "text-black-500" : "text-white"} text-2xl hover:text-white hover:bg-red-400 ${Theme === "dark" ? "bg-[#F2AA4CFF]" : "bg-red-400"} border-solid px-3 rounded`}
            key={index}
          >
            <a className='text-xl' href={item.href} target={"blank"}>
              <Icon as={item.icon} color={Theme === 'dark' ? 'blackAlpha.800' : "#fff"} />

            </a>
          </li>
        );
      })}

    </ul>
  );
};

export default Socials;
